import {
  FETCH_ATTENDANCE_ADMIN_REQUEST,
  FETCH_ATTENDANCE_ADMIN_SUCCESS,
  FETCH_ATTENDANCE_ADMIN_FAILURE,
} from "../constants/AttendanceAdminConstants";

import AttendanceAdminService from "../service/AttendanceAdminService";

export const fetchAttendanceAdmin = (date) => async (dispatch) => {
  if (!date) {
    console.error("Date is required");
    return;
  }

  try {
    dispatch({ type: FETCH_ATTENDANCE_ADMIN_REQUEST });

    const data = await AttendanceAdminService.getAll(date);

    dispatch({
      type: FETCH_ATTENDANCE_ADMIN_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: FETCH_ATTENDANCE_ADMIN_FAILURE,
      payload:
        error.response?.data?.message || error.message || "Failed to fetch",
    });
  }
};
